var exports = {
  "rf": "VoiceMessageComposerModal.module__body___RjBFMl",
  "BK": "VoiceMessageComposerModal.module__helpText___RjBFMl",
  "kc": "VoiceMessageComposerModal.module__errorText___RjBFMl",
  "mI": "VoiceMessageComposerModal.module__meta___RjBFMl",
  "sG": "VoiceMessageComposerModal.module__recordingStatus___RjBFMl",
  "ne": "VoiceMessageComposerModal.module__controls___RjBFMl",
  "hZ": "VoiceMessageComposerModal.module__buttonInner___RjBFMl",
};

module.exports = exports;
